import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import "./App.css";

const isCredulocker = !!document.getElementById("vmAccessDocumentWidget");
const isDocumentViewerWidget = !!document.getElementById("vmDocumentViewerWidget");
const isVerificationWidget = !!document.getElementById("vmVerificationWidget");

if (isCredulocker) {
  const container = document.querySelector("#vmAccessDocumentWidget");
  const shadowContainer = container.attachShadow({ mode: "open" });
  const shadowRootElement = document.createElement("div");
  shadowContainer.appendChild(shadowRootElement);

  const cache = createCache({
    key: "css",
    prepend: true,
    container: shadowContainer,
  });

  ReactDOM.createRoot(shadowRootElement).render(
    <BrowserRouter>
      <CacheProvider value={cache}>
        <App isCredulocker={true} shadowRootElement={shadowRootElement} />
      </CacheProvider>
    </BrowserRouter>,
  );
} else if (isDocumentViewerWidget) {
  const container = document.querySelector("#vmDocumentViewerWidget");
  const shadowContainer = container.attachShadow({ mode: "open" });
  const shadowRootElement = document.createElement("div");
  shadowContainer.appendChild(shadowRootElement);
  const displayId = container?.dataset?.docid;

  const cache = createCache({
    key: "css",
    prepend: true,
    container: shadowContainer,
  });


  ReactDOM.createRoot(shadowRootElement).render(
    <BrowserRouter>
      <CacheProvider value={cache}>
        <App displayId={displayId} isDocumentViewerWidget={true} shadowRootElement={shadowRootElement} />
      </CacheProvider>
    </BrowserRouter>,
  );
} else if (isVerificationWidget) {
  const container = document.querySelector("#vmVerificationWidget");
  const shadowContainer = container.attachShadow({ mode: "open" });
  const shadowRootElement = document.createElement("div");
  shadowContainer.appendChild(shadowRootElement);

  const cache = createCache({
    key: "css",
    prepend: true,
    container: shadowContainer,
  });

  ReactDOM.createRoot(shadowRootElement).render(
    <CacheProvider value={cache}>
      <App isVerificationWidget={true} shadowRootElement={shadowRootElement} />
    </CacheProvider>)
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
}

reportWebVitals();
